import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import Component from './Component'
import ComponentProvider from './contexts/CustomFormBuilderManagerContext/Provider'
import { Props } from './contexts/CustomFormBuilderManagerContext/Provider'
import { CustomForm } from '../../types'

type CustomFormQuestionResponse = Response & {
  body?: {
    form_question?: CustomFormQuestion
  }
}

type CustomFormResponse = Response & {
  body?: {
    form?: CustomForm
  }
}

type CustomFormReadQuestionsResponse = Response & {
  body?: {
    form_question?: {
      elements?: CustomFormQuestion[]
    }
  }
}

export type CustomFormPermissions = {
  updateForm?: boolean
  updateFormVisibility?: boolean
  deleteForm?: boolean
  createFormQuestion?: boolean
  updateFormQuestion?: boolean
  deleteFormQuestion?: boolean
}

export type CustomFormBuilderProps = {
  permissions?: CustomFormPermissions
  children?: JSX.Element
  _updateForm?: (params: { data: CustomForm; formId?: string }) => Promise<Response>
  _updateFormVisibility?: (params: { data: { is_protected: boolean }; formId?: string }) => Promise<Response>
  _deleteForm: () => Promise<Response>
  _getForm: () => Promise<CustomFormResponse>
  _getQuestion: (params: { questionSlug?: string }) => Promise<CustomFormQuestionResponse>
  _readQuestions: () => Promise<CustomFormReadQuestionsResponse>
  _createQuestion: (params: { data: CustomFormQuestion }) => Promise<CustomFormQuestionResponse>
  _updateQuestion: (params: { data: CustomFormQuestion; questionId?: string }) => Promise<CustomFormQuestionResponse>
  _deleteQuestion: (params: { questionId?: string }) => Promise<Response>
}

export default function CustomFormBuilder(props: Props) {
  return (
    <ComponentProvider {...props}>
      <Component />
    </ComponentProvider>
  )
}
